import { apiMindbox, MINDBOX_OPERATIONS } from '@/fo/api/mindbox';

const clearAll = async () => {
  return await apiMindbox(MINDBOX_OPERATIONS.CART_CLEAR, {
    data: {}
  });
};

const update = async (
  items: { id: string; count: number; price: number }[]
) => {
  return await apiMindbox(MINDBOX_OPERATIONS.CART_CREATE, {
    productList: items.map(({ id, count, price }) => ({
      product: {
        ids: {
          dreameSite: id
        }
      },
      count,
      pricePerItem: price
    }))
  });
};

export const cartMindboxService = {
  clearAll,
  update
};
